import {
  TextInputIcon,
  HelpCircleIcon,
  Columns01Icon,
  Image03Icon,
  Link03Icon,
  CheckSquareIcon,
  CheckCircleIcon,
  Scales01Icon,
} from '../../../assets/icons'
import { Flex, VStack, Icon, Button, Tooltip } from '@chakra-ui/react'
import { ContentType } from '../../../types/content/content'
import { ContentItemType } from '../../../types/content/contentItems'

interface SideBarProps {
  handleAddQuestion: (qType: ContentItemType) => void
  bigger?: boolean
  contentType: ContentType
}

const SideBar: React.FC<SideBarProps> = ({ handleAddQuestion, bigger = false, contentType }) => {
  interface IconWithHandler {
    icon: React.FC
    type: ContentItemType
  }

  const iconsWithHandlers: IconWithHandler[] = [
    { icon: Scales01Icon, type: ContentItemType.SurveyRating },
    { icon: CheckCircleIcon, type: ContentItemType.SurveyMCQ },
    { icon: CheckSquareIcon, type: ContentItemType.TrainingCheckbox },
    { icon: CheckSquareIcon, type: ContentItemType.LearningCheckbox },
    { icon: CheckCircleIcon, type: ContentItemType.TrainingMCQ },
    { icon: HelpCircleIcon, type: ContentItemType.Short },
    { icon: HelpCircleIcon, type: ContentItemType.SurveyText },
    { icon: TextInputIcon, type: ContentItemType.Paragraph },
    { icon: Columns01Icon, type: ContentItemType.Section },
    { icon: Image03Icon, type: ContentItemType.Media },
    { icon: Link03Icon, type: ContentItemType.URL },
  ]

  const filteredIcons =
    contentType === 'training'
      ? iconsWithHandlers.filter(
          (iconItem) =>
            iconItem.type !== ContentItemType.Short &&
            iconItem.type !== ContentItemType.SurveyRating &&
            iconItem.type !== ContentItemType.SurveyMCQ &&
            iconItem.type !== ContentItemType.SurveyText &&
            iconItem.type !== ContentItemType.LearningCheckbox,
        )
      : contentType === 'survey'
        ? iconsWithHandlers.filter(
            (iconItem) =>
              iconItem.type !== ContentItemType.TrainingCheckbox &&
              iconItem.type !== ContentItemType.TrainingMCQ &&
              iconItem.type !== ContentItemType.Short &&
              iconItem.type !== ContentItemType.LearningCheckbox,
          )
        : contentType === 'learning'
          ? iconsWithHandlers.filter(
              (iconItem) =>
                iconItem.type !== ContentItemType.TrainingCheckbox &&
                iconItem.type !== ContentItemType.TrainingMCQ &&
                iconItem.type !== ContentItemType.Short
            )
          : iconsWithHandlers.filter(
              (iconItem) =>
                iconItem.type !== ContentItemType.TrainingMCQ &&
                iconItem.type !== ContentItemType.TrainingCheckbox &&
                iconItem.type !== ContentItemType.SurveyRating &&
                iconItem.type !== ContentItemType.SurveyText &&
                iconItem.type !== ContentItemType.SurveyMCQ &&
                iconItem.type !== ContentItemType.LearningCheckbox,
            )

  const addQuestion = (type: ContentItemType) => {
    handleAddQuestion(type)
  }

  const sideBoxWidth = bigger ? '64px' : '48px'
  const sideBoxPadding = bigger ? '16px' : '12px'
  const iconSize = bigger ? '22px' : '18px'
  const buttonSpacing = bigger ? '12px' : '8px'

  const getTooltipLabel = (type: ContentItemType): string => {
    const labels: Record<string, string> = {
      'url': 'URL',
      'paragraph': 'Add learning text',
      'short': 'Add short answer',
      'survey_rating': 'Add rating scale',
      'survey_multiple_choice': 'Add multiple choice',
      'training_multiple_choice': 'Add quiz question',
      'training_checkbox': 'Add multi-select quiz',
      'checkbox': 'Add completion checkbox',
      'survey_text': 'Add written response',
      'section': 'Add section header',
      'media': 'Add image or video',
    }
    return labels[type.toLowerCase()] || type.charAt(0).toUpperCase() + type.slice(1)
  }

  return (
    <Flex
      direction="column"
      bg="#FFFFFF"
      w={sideBoxWidth}
      p={sideBoxPadding}
      borderBottomRadius="12px"
     // boxLeftShadow="0 2px 8px rgba(0,0,0,0.06)"
    //  borderLeft="1px solid"
    //  borderBottom="1px solid"
    //  borderRight="1px solid"
   //   borderColor="solid.50"
      maxH="600px"
      position="sticky" top="24px"
    >
      <VStack spacing={buttonSpacing} justify="flex-start" w="100%">
        {filteredIcons.map(({ icon: IconComponent, type }, index) => (
          <Tooltip
            key={index}
            label={getTooltipLabel(type)}
            placement="right"
            hasArrow
            bg="solid.900"
            color="solid.0"
            fontSize="12px"
            px="12px"
            py="6px"
            borderRadius="6px"
          >
            <Button 
              variant="sidebarIcon" 
              onClick={() => addQuestion(type)}
              aria-label={getTooltipLabel(type)}
              w="100%"
              h={bigger ? '44px' : '36px'}
              borderRadius="8px"
              bg="solid.0"
              border="1px solid"
              borderColor="solid.50"
              _hover={{ 
                bg: 'solid.25',
                borderColor: 'solid.300',
                transform: 'translateY(-1px)',
                boxShadow: '0 2px 4px rgba(0,0,0,0.08)'
              }}
              transition="all 0.2s"
            >
              <Icon boxSize={iconSize} color="solid.600" fill="none">
                <IconComponent />
              </Icon>
            </Button>
          </Tooltip>
        ))}
      </VStack>
    </Flex>
  )
}

export default SideBar
